module.exports = __webpack_public_path__ + "static/media/1.9132afe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/1.png
// module id = 488
// module chunks = 0